import { BaseModel } from "sjs-base-model";

export default class SimulazioneStepOneCollapseModel extends BaseModel {
    public readonly rataDurataCollapse: boolean = true;
    public readonly importoRataCollapse: boolean = false;
    public readonly importoDurataCollapse: boolean = false;

    constructor(data: Partial<SimulazioneStepOneCollapseModel>) {
        super();

        this.update(data);
    }
}
